import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebaseService';

export type CorrectionType = 'innmark_as_utmark' | 'utmark_as_innmark' | 'other';

export interface MapCorrectionData {
  userId: string;
  latitude: number;
  longitude: number;
  correctionType: CorrectionType;
  comment: string;
  status: 'pending';
  createdAt: any;
}

export async function submitMapCorrection(opts: {
  userId: string;
  latitude: number;
  longitude: number;
  correctionType: CorrectionType;
  comment: string;
}): Promise<string> {
  const ref = await addDoc(collection(db, 'map_corrections'), {
    userId: opts.userId,
    latitude: opts.latitude,
    longitude: opts.longitude,
    correctionType: opts.correctionType,
    comment: opts.comment,
    status: 'pending',
    createdAt: serverTimestamp()
  });
  return ref.id;
}
